import React from 'react';

export const QuoteGraphic = () => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 45"
    role="decorative"
    aria-hidden="true"
  >
    <path
      d="M47.15 18.18C48.037 10.494 54.097 7.39 64 6.06V0C44.49.591 33.995 10.199 33.995 26.162c0 10.79 6.06 18.18 15.668 18.18C57.644 44.342 64 39.316 64 31.039c0-7.538-4.582-11.38-10.79-12.859h-6.06zm-33.995 0c.887-7.686 6.947-10.79 16.85-12.12V0C10.495.591 0 10.199 0 26.162c0 10.79 6.06 18.18 15.667 18.18 7.982 0 14.338-5.026 14.338-13.303 0-7.538-4.582-11.38-10.79-12.859h-6.06z"
      fill="#BDE2F5"
    ></path>
  </svg>
);
